import { BasicValueUnitGetModuleFactory } from '../../endpoints/basic/valueUnit/get.module.js';
import '../../endpoints/index/constituents/list.module.js';
import '../../endpoints/instrument/getByNotation.module.js';
import '../../endpoints/instrument/crossreference.module.js';
import '../../endpoints/instrument/coupon/keyData/get.module.js';
import '../../endpoints/instrument/exchangeRate/getByISOCode.module.js';
import '../../endpoints/notation/crossReference/listByInstrument.module.js';
import '../../endpoints/notation/keyFigures/get.module.js';
import '../../endpoints/notation/get.module.js';
import { PricesListModuleFactory } from '../../endpoints/prices/list.module.js';
import '../../endpoints/debtInstrument/get.module.js';
import '../../endpoints/legalEntity/company/get.module.js';
import '../../endpoints/legalEntity/address/list.module.js';
import '../../endpoints/news/article/get.module.js';
import '../../endpoints/news/article/searchByText.module.js';
import '../../endpoints/fund/shareClass/get.module.js';
import '../../endpoints/instrument/benchmark/list.module.js';
import '../../endpoints/prices/bidAsk/list.module.js';
import '../../endpoints/securitizedDerivative/get.module.js';
import '../../endpoints/company/keyItems/fiscalYear/listByInstrument.module.js';
import '../../endpoints/instrument/category/list.module.js';
import '../../endpoints/securitizedDerivative/keyFigures/notation/get.module.js';
import '../../endpoints/notation/searchByText.module.js';
import '../../endpoints/prices/timeSeries/eod/list.module.js';
import '../../endpoints/prices/timeSeries/intraday/subsample/list.module.js';
import '../../endpoints/company/board/listByInstrument.module.js';
import '../../endpoints/prices/orderbook/aggregated/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/get.module.js';
import '../../endpoints/company/estimates/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/benchmark/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/type/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/performance/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/fee/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/manager/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/riskFigures/listByInstrument.module.js';
import '../../endpoints/stock/owner/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/evaluation/getByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/holding/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/issuer/get.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/eod/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/intraday/ranking/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/listByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/type/list.module.js';
import '../../endpoints/securitizedDerivative/notation/screener/search.module.js';
import '../../endpoints/basic/market/list.module.js';
import '../../endpoints/basic/language/list.module.js';
import '../../endpoints/basic/valueUnit/currency/main/list.module.js';
import '../../endpoints/basic/frequency/type/list.module.js';
import '../../endpoints/legalEntity/list.module.js';
import '../../endpoints/instrument/coupon/interestRate/type/list.module.js';
import '../../endpoints/instrument/backgroundText/listByInstrument.module.js';
import '../../endpoints/stock/recommendation/aggregate/history/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/investmentFocus/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/exchange/list.module.js';
import '../../endpoints/stock/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/status/get.module.js';
import '../../endpoints/instrument/complianceProperty/listByInstrument.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/list.module.js';
import '../../endpoints/vendor/tradingCentral/technicalAnalysis/get.module.js';
import '../../endpoints/calendarEvent/list.module.js';
import '../../endpoints/calendarEvent/get.module.js';
import '../../endpoints/stock/notation/screener/search.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/figure/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/category/ranking/listByInstrument.module.js';
import '../../endpoints/news/article/listByMediaKind.module.js';
import '../../endpoints/documents/searchByInstrument.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/narrative/get.module.js';
import '../../endpoints/debtInstrument/keyFigures/notation/get.module.js';
import '../../endpoints/securitizedDerivative/notation/ranking/intraday/list.module.js';
import '../../endpoints/notation/keyFigures/list.module.js';
import '../../endpoints/instrument/legalEntity/backgroundText/listByInstrument.module.js';
import '../../endpoints/securitizedDerivative/underlying/list.module.js';
import '../../endpoints/basic/market/get.module.js';
import '../../endpoints/securitizedDerivative/issuer/search.module.js';
import '../../endpoints/prices/tradingSchedule/event/list.module.js';
import '../../endpoints/debtInstrument/issuer/search.module.js';
import '../../endpoints/debtInstrument/notation/screener/search.module.js';
import '../../endpoints/watchlist/create.module.js';
import '../../endpoints/watchlist/delete.module.js';
import '../../endpoints/watchlist/list.module.js';
import '../../endpoints/watchlist/get.module.js';
import '../../endpoints/watchlist/modify.module.js';
import '../../endpoints/watchlist/position/create.module.js';
import '../../endpoints/watchlist/position/delete.module.js';
import '../../endpoints/watchlist/position/list.module.js';
import '../../endpoints/watchlist/position/get.module.js';
import '../../endpoints/watchlist/position/modify.module.js';
import '../../endpoints/basic/region/list.module.js';
import '../../endpoints/portfolio/transaction/list.module.js';
import '../../endpoints/portfolio/list.module.js';
import '../../endpoints/portfolio/position/list.module.js';
import '../../endpoints/portfolio/get.module.js';
import '../../endpoints/portfolio/create.module.js';
import '../../endpoints/portfolio/modify.module.js';
import '../../endpoints/portfolio/delete.module.js';
import '../../endpoints/portfolio/transaction/create.module.js';
import '../../endpoints/portfolio/transaction/delete.module.js';
import '../../endpoints/portfolio/transaction/modify.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/shareClass/screener/search.module.js';
import '../../endpoints/basic/region/country/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/breakdown/element/list.module.js';
import '../../endpoints/instrument/get.module.js';
import '../../endpoints/portfolio/evaluation/list.module.js';
import '../../endpoints/stock/recommendation/aggregate/get.module.js';
import '../../endpoints/prices/timeSeries/eod/subsample/get.module.js';
import '../../endpoints/category/listBySystem.module.js';
import '../../endpoints/alerting/prices/basic/alert/get.module.js';
import { AlertingPricesBasicAlertListModuleFactory } from '../../endpoints/alerting/prices/basic/alert/list.module.js';
import '../../endpoints/alerting/prices/basic/alert/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/create.module.js';
import '../../endpoints/alerting/prices/basic/trigger/delete.module.js';
import '../../endpoints/alerting/prices/basic/trigger/get.module.js';
import { AlertingPricesBasicTriggerListModuleFactory } from '../../endpoints/alerting/prices/basic/trigger/list.module.js';
import '../../endpoints/alerting/prices/basic/trigger/modify.module.js';
import '../../endpoints/company/logo/get.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/assetClass/list.module.js';
import '../../endpoints/product/wmp/portfolioAnalytics/allocation/sector/list.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/managers/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/benchmarkDetails/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/summary/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/classifications/get.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/costsFees/get.module.js';
import '../../endpoints/factset/content/factsetOwnership/v1/fundHoldings/get.module.js';
import '../../endpoints/fund/holding/listByInstrument.module.js';
import '../../endpoints/factset/content/factsetFunds/v1/returnsSnapshot/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScores/get.module.js';
import '../../endpoints/factset/content/factsetEsg/sasbScoresAll/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/annualizedTotalReturn/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/cumulativeTotalReturn/list.module.js';
import '../../endpoints/vendor/morningstar/onDemand/fund/esg/getByInstrument.module.js';
import '../../endpoints/fund/breakdown/position/ListByInstrument.module.js';
import '../../endpoints/product/widgets/portfolio/holdings/list.module.js';
import '../../endpoints/product/widgets/portfolio/weights/list.module.js';
import '../../endpoints/product/widgets/portfolio/characteristics/list.module.js';
import '../../endpoints/product/widgets/portfolio/performance/attribution/list.module.js';
import '../../endpoints/notation/crossReference/listBySymbol.module.js';
import '../../endpoints/notation/crossReference/listByISIN.module.js';
import '../../endpoints/instrument/notation/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/countries/get.module.js';
import '../../endpoints/news/article/type/list.module.js';
import '../../endpoints/news/publisher/list.module.js';
import '../../endpoints/category/system/list.module.js';
import '../../endpoints/news/distributor/list.module.js';
import '../../endpoints/factset/content/factsetGeorev/v1/regions/get.module.js';
import '../../endpoints/product/widgets/portfolio/performance/discreteTotalReturn/list.module.js';
import '../../endpoints/index/get.module.js';
import '../../endpoints/fund/notation/screener/search.module.js';
import '../../endpoints/basic/valueUnit/list.module.js';
import '../../endpoints/fund/issuer/search.module.js';
import '../../endpoints/rating/grade/listBySystem.module.js';
import '../../endpoints/fund/notation/screener/valueRanges/get.module.js';
import { Mdg2StoreModuleFactory } from '../../abstracts/Mdg2StoreModuleFactory.js';
import '../../abstracts/Mdg2EndpointStoreModuleFactory.js';
import '../../abstracts/Mdg2SubscriptionStoreModuleFactory.js';
import 'vue';
import 'lodash.matches';
import 'lodash.set';
import { getEndpointOptions, convertMdg2DateTimeResponse } from '../../helpers/common.js';
import '../../subscriptions/news/article/searchByText.module.js';
import '../../subscriptions/news/article/listByMediaKind.module.js';
import '../../subscriptions/prices/get.module.js';
import '../../subscriptions/prices/bidAsk/get.module.js';
import '../../subscriptions/vendor/tradingCentral/technicalAnalysis/list.module.js';
import { AlertingPricesBasicAlertListSubscriptionModuleFactory } from '../../subscriptions/alerting/prices/basic/alert/list.module.js';
import '../../subscriptions/prices/orderbook/aggregated/get.module.js';

var _a, _b, _c;
class AlertTriggerToggleStoreModuleFactory extends Mdg2StoreModuleFactory {
  constructor() {
    super(...arguments);
    this.isPushEnabled = (_c = (_b = (_a = this.options) == null ? void 0 : _a.push) == null ? void 0 : _b.enabled) != null ? _c : true;
  }
  async updateComponentsInputs(payload) {
    let isResponseSuccessful = true;
    try {
      await Promise.all([this.updateAlertingPricesBasicTriggerList(), this.updateAlertingPricesBasicAlertList(), this.updateBasicValueUnitGet(payload.id)]);
      if (this.isPushEnabled) {
        await this.updateAlertingPricesBasicAlertListSubscription();
      }
    } catch (error) {
      this.logger.error(error);
      isResponseSuccessful = false;
    }
    return Promise.resolve(isResponseSuccessful);
  }
  async cleanUp(payload) {
    if (this.isPushEnabled) {
      await this.removeInactiveAlertingPricesBasicAlertListSubscriptions();
    }
    return Promise.resolve(true);
  }
  getEndpoints() {
    var _a2, _b2, _c2, _d;
    if (!this.endpoints) {
      const endpointConfiguration = (_a2 = this.options) == null ? void 0 : _a2.endpointConfiguration;
      const alertingPricesBasicAlertListSubscriptionOptions = {
        granularity: (_d = (_c2 = (_b2 = this.options) == null ? void 0 : _b2.push) == null ? void 0 : _c2.granularity) != null ? _d : "1S",
        ...getEndpointOptions(endpointConfiguration, "alertingPricesBasicAlertListSubscription")
      };
      this.endpoints = {
        alertingPricesBasicTriggerList: this.getModuleEntity(
          AlertingPricesBasicTriggerListModuleFactory,
          getEndpointOptions(endpointConfiguration, "alertingPricesBasicTriggerList")
        ),
        alertingPricesBasicAlertListSubscription: this.getModuleEntity(AlertingPricesBasicAlertListSubscriptionModuleFactory, alertingPricesBasicAlertListSubscriptionOptions),
        alertingPricesBasicAlertList: this.getModuleEntity(AlertingPricesBasicAlertListModuleFactory, getEndpointOptions(endpointConfiguration, "alertingPricesBasicAlertList")),
        pricesList: this.getModuleEntity(PricesListModuleFactory, getEndpointOptions(endpointConfiguration, "pricesList")),
        basicValueUnitGet: this.getModuleEntity(BasicValueUnitGetModuleFactory, getEndpointOptions(endpointConfiguration, "basicValueUnitGet"))
      };
    }
    return this.endpoints;
  }
  getAlertingPricesBasicAlertListRequest() {
    return {};
  }
  getAlertingPricesBasicAlertListData() {
    var _a2;
    try {
      const request = this.getAlertingPricesBasicAlertListRequest();
      const response = this.getEndpoints().alertingPricesBasicAlertList.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateAlertingPricesBasicAlertList() {
    try {
      const request = this.getAlertingPricesBasicAlertListRequest();
      return this.getEndpoints().alertingPricesBasicAlertList.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getAlertingPricesBasicTriggerListRequest() {
    return { meta: { pagination: { limit: 500 } } };
  }
  getAlertingPricesBasicTriggerListData() {
    var _a2;
    try {
      const request = this.getAlertingPricesBasicTriggerListRequest();
      const response = this.getEndpoints().alertingPricesBasicTriggerList.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateAlertingPricesBasicTriggerList() {
    const request = this.getAlertingPricesBasicTriggerListRequest();
    return this.getEndpoints().alertingPricesBasicTriggerList.updateState(request);
  }
  getAlertingPricesBasicAlertListSubscriptionRequest() {
    return {};
  }
  getAlertingPricesBasicAlertListSubscriptionData() {
    var _a2;
    try {
      const request = this.getAlertingPricesBasicAlertListSubscriptionRequest();
      const response = this.getEndpoints().alertingPricesBasicAlertListSubscription.getData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateAlertingPricesBasicAlertListSubscription() {
    try {
      const request = this.getAlertingPricesBasicAlertListSubscriptionRequest();
      return this.getEndpoints().alertingPricesBasicAlertListSubscription.fetchObservable(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  async removeInactiveAlertingPricesBasicAlertListSubscriptions() {
    try {
      const request = this.getAlertingPricesBasicAlertListSubscriptionRequest();
      return this.getEndpoints().alertingPricesBasicAlertListSubscription.removeSubscriptionIfInactive(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getPricesListNotationDataRequest(id) {
    return { id, quality: "BST", sameQuality: false };
  }
  getPricesListRequest(identifiers) {
    return { identifiers, identifierType: "idNotation", quality: "BST", sameQuality: false };
  }
  getPricesListData(id) {
    var _a2;
    try {
      const request = this.getPricesListNotationDataRequest(id);
      const response = this.getEndpoints().pricesList.getNotationData(request);
      return (_a2 = response == null ? void 0 : response.data) != null ? _a2 : null;
    } catch (e) {
      return null;
    }
  }
  async updatePricesList(ids) {
    try {
      const request = this.getPricesListRequest(ids);
      return this.getEndpoints().pricesList.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getBasicValueUnitGetRequest(id) {
    return { id };
  }
  getBasicValueUnitGetData(id) {
    var _a2, _b2;
    try {
      const valueUnitId = (_a2 = this.getPricesListData(id)) == null ? void 0 : _a2.valueUnit.id;
      if (!valueUnitId) {
        return null;
      }
      const request = this.getBasicValueUnitGetRequest(valueUnitId);
      const response = this.getEndpoints().basicValueUnitGet.getData(request);
      return (_b2 = response == null ? void 0 : response.data) != null ? _b2 : null;
    } catch (e) {
      return null;
    }
  }
  async updateBasicValueUnitGet(id) {
    var _a2;
    try {
      await this.updatePricesList([id]);
      const valueUnitId = (_a2 = this.getPricesListData(id)) == null ? void 0 : _a2.valueUnit.id;
      if (!valueUnitId) {
        throw new Error("could not get value unit id");
      }
      const request = this.getBasicValueUnitGetRequest(valueUnitId);
      return this.getEndpoints().basicValueUnitGet.updateState(request);
    } catch (e) {
      this.logger.error(e);
      return false;
    }
  }
  getResponse(payload) {
    return {
      data: this.getResponseData(payload)
    };
  }
  getResponseData(payload) {
    var _a2, _b2, _c2, _d, _e, _f;
    const triggerListResults = this.getAlertingPricesBasicTriggerListData();
    const trigger = this.getLatestTrigger(payload.id, triggerListResults != null ? triggerListResults : []);
    const alertListResults = this.isPushEnabled ? this.getAlertingPricesBasicAlertListSubscriptionData() : this.getAlertingPricesBasicAlertListData();
    const alert = this.getLatestAlert(payload.id, alertListResults != null ? alertListResults : []);
    const valueUnit = this.getBasicValueUnitGetData(payload.id);
    const status = this.getAlertStatus(alert, trigger);
    const alertLimitType = this.getAlertLimitType(alert);
    return {
      status,
      currency: (_b2 = (_a2 = valueUnit == null ? void 0 : valueUnit.code) != null ? _a2 : valueUnit == null ? void 0 : valueUnit.isoCode) != null ? _b2 : null,
      limit: {
        above: (_c2 = trigger == null ? void 0 : trigger.range.upperLimit) != null ? _c2 : null,
        below: (_d = trigger == null ? void 0 : trigger.range.lowerLimit) != null ? _d : null
      },
      trigger: {
        limitType: alertLimitType,
        price: (_e = alert == null ? void 0 : alert.price.value) != null ? _e : null,
        dateTime: convertMdg2DateTimeResponse((_f = alert == null ? void 0 : alert.price.time) != null ? _f : null)
      }
    };
  }
  getAlertLimitType(alert) {
    var _a2, _b2;
    const alertPrice = (_a2 = alert == null ? void 0 : alert.price.value) != null ? _a2 : null;
    const triggerUpperLimit = (_b2 = alert == null ? void 0 : alert.trigger.range.upperLimit) != null ? _b2 : null;
    return alertPrice && triggerUpperLimit && alertPrice > triggerUpperLimit ? "above" : "below";
  }
  getLatestAlert(id, alertList) {
    return alertList.find((alert) => alert.trigger.notation.id === id);
  }
  getLatestTrigger(id, triggerList) {
    return triggerList.find((trigger) => trigger.notation.id === id);
  }
  getAlertStatus(alert, trigger) {
    if ((alert == null ? void 0 : alert.trigger.id) && alert.trigger.id === (trigger == null ? void 0 : trigger.id)) {
      return "triggered";
    }
    return (trigger == null ? void 0 : trigger.status.code) === "active" ? "active" : "inactive";
  }
}

export { AlertTriggerToggleStoreModuleFactory };
